





























import Vue from 'vue'
import TypeIt from 'typeit'
import GmsStart from './startup_logs/gms'
import MsmcStart from './startup_logs/msmc'
import SscStart from './startup_logs/ssc'
import IpsnStart from './startup_logs/ipsn'
import HaStart from './startup_logs/ha'
import GalsimStart from './startup_logs/galsim'
import { HorusStart, HorusChat } from './startup_logs/horus'
import { getModule } from 'vuex-module-decorators'
import { UserStore } from '@/store'
import { UserProfile } from '@/user'

export default Vue.extend({
  name: 'cc-log',
  data: () => ({
    typer: {},
    text: [],
    lock: false,
  }),
  computed: {
    profile(): UserProfile {
      const store = getModule(UserStore, this.$store)
      return store.UserProfile
    },
    theme(): string {
      return this.profile.Theme
    },
  },
  watch: {
    theme(newval, oldval) {
      if (newval !== oldval) this.restart()
    },
  },
  async mounted() {
    this.lock = true
    this.restart()
  },
  methods: {
    restart() {
      if (this.typer.hasOwnProperty('destroy')) this.typer.destroy(true)
      if (this.$refs.completed.innerHTML) this.$refs.completed.innerHTML = ''
      if (this.$refs.output.innerHTML) this.$refs.output.innerHTML = ''
      this.start()
    },
    async start() {
      await Vue.nextTick()
      this.typer = new TypeIt(this.$refs.output, {
        speed: 2,
        nextStringDelay: 5,
        lifeLike: false,
        cursor: false,
        startDelete: false,
        beforeString: () => {
          this.$refs.output?.scrollIntoView({ block: 'end' })
        },
        afterString: () => {
          this.$refs.output?.scrollIntoView({ block: 'end' })
        },
        afterComplete: () => {
          if (this.profile.Theme === 'horus') {
            HorusChat(this.$refs.output)
          } else {
            this.lock = false
          }
        },
      })

      switch (this.profile.Theme) {
        case 'horus':
          // this.typer.go()
          HorusStart(this.typer)
          // HorusChat(this.typer)
          break
        case 'msmc':
          MsmcStart(this.typer)
        case 'ssc':
          SscStart(this.typer)
        case 'ipsn':
          IpsnStart(this.typer)
        case 'ha':
          HaStart(this.typer)
        case 'galsim':
          GalsimStart(this.typer)
        default:
          GmsStart(this.typer)
          break
      }
    },
    print(user: string, response: string) {
      if (this.lock) return
      this.lock = true

      this.typer.destroy()

      //collect written strings so TypeIt doesn't erase them
      if (this.$refs.completed.innerHTML) this.$refs.completed.innerHTML += '<br>'
      this.$refs.completed.innerHTML += this.$refs.output.innerHTML
      this.$refs.output.innerHTML = ''

      this.typer = new TypeIt(this.$refs.output, {
        speed: 32,
        lifeLike: true,
        nextStringDelay: 7,
        cursor: false,
        beforeString: () => {
          this.$refs.output?.scrollIntoView({ block: 'end' })
        },
        afterString: () => {
          this.$refs.output?.scrollIntoView({ block: 'end' })
        },
        afterComplete: () => {
          this.lock = false
        },
      })
        .type(`$ `)
        .type(`<span class="stark-text--text">${user}</span>↵`)
        .pause(100)
        .options({ speed: 3, lifeLike: false })
        .break()
        .type('>')
        .type(
          `//[<span class="accent--text">COMP/CON</span>: <span class="stark--text">${response}</span>]`
        )
        .type(' ')
        .go()
    },
  },
})
